class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    const closeButton = this.querySelector('button[type="button"]') || this.querySelector('.search-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
    const resetButton = this.querySelector('button[type="reset"]');
    if (resetButton) {
      resetButton.addEventListener('click', this.reset.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) && !event.target.closest('summary')) {
      this.close();
    }
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    this.detailsContainer.classList.add('menu-opening');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus();
    
    // Start closing animation by removing menu-opening class
    this.detailsContainer.classList.remove('menu-opening');
    
    // Remove event listeners and classes immediately
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    
    // Wait for animation to complete before removing open attribute
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
    }, 500); // Match --duration-long (500ms)
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);
